<div class="wrap">
    <div *ngIf="loading === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div class="uk-form-horizontal uk-margin-large" uk-grid *ngIf="loading === false">

        <!-- Price form -->
        <div class="uk-width-6-10">
            <h3 class="uk-heading-divider bold">Tarification pour l'adhérent</h3>
            <div class="uk-margin">
                <label class="uk-form-label" for="form-horizontal-text">Type</label>
                <div style="margin-left: 15px" uk-form-custom="target: > * > span:first-child">
                    <select [(ngModel)]="prices.priceType">
                        <option value="hours">Par heure</option>
                        <option value="blocks">Par bloc</option>
                    </select>
                    <button class="uk-button uk-button-default" type="button" tabindex="-1">
                        <span></span>
                    </button>
                </div>
            </div>
            <div class="uk-margin" *ngIf="prices.priceType === 'blocks'">
                <label class="uk-form-label" for="form-horizontal-text">Horaires par bloc</label>
                <div class="uk-form-controls uk-grid-small" uk-grid style="margin-left: -15px; margin-top: 0px;">
                    <div class="uk-width-1-2 subtitle">
                        Bloc 1
                    </div>
                    <div class="uk-width-1-2 subtitle">
                        Bloc 2
                    </div>

                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.blocks[0].start">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.blocks[0].end">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.blocks[1].start">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.blocks[1].end">
                    </div>

                    <div class="uk-width-1-2 subtitle uk-margin-small-top">
                        Bloc 3
                    </div>
                    <div class="uk-width-1-2 subtitle uk-margin-small-top">
                        Bloc 4
                    </div>
                    
                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.blocks[2].start">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.blocks[2].end">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.blocks[3].start">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.blocks[3].end">
                    </div>
                </div>
            </div>
            <div class="uk-margin" *ngIf="prices.priceType === 'blocks'">
                <label class="uk-form-label" for="form-horizontal-text">Prix par bloc</label>
                <div class="uk-form-controls uk-grid-small" uk-grid style="margin-left: -15px; margin-top: 0px;">
                    <div class="uk-width-1-4 subtitle">
                        Bloc 1
                    </div>
                    <div class="uk-width-1-4 subtitle">
                        Bloc 2
                    </div>
                    <div class="uk-width-1-4 subtitle">
                        Bloc 3
                    </div>
                    <div class="uk-width-1-4 subtitle">
                        Bloc 4
                    </div>
                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.blocks[0].amount">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.blocks[1].amount">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.blocks[2].amount">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.blocks[3].amount">
                    </div>
                </div>
            </div>
            <div class="uk-margin" *ngIf="prices.priceType === 'hours'">
                <label class="uk-form-label" for="form-horizontal-text">Prix horaire</label>
                <div class="uk-form-controls uk-grid-small" uk-grid style="margin-left: -15px; margin-top: 0px;">
                    <div class="uk-width-1-4 subtitle">
                        Lundi
                    </div>
                    <div class="uk-width-1-4 subtitle">
                        Mardi
                    </div>
                    <div class="uk-width-1-4 subtitle">
                        Mercredi
                    </div>
                    <div class="uk-width-1-4 subtitle">
                        Jeudi
                    </div>

                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.hourPrices[0]">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.hourPrices[1]">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.hourPrices[2]">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.hourPrices[3]">
                    </div>

                    <div class="uk-width-1-4 subtitle uk-margin-small-top">
                        Vendredi
                    </div>
                    <div class="uk-width-1-4 subtitle uk-margin-small-top">
                        Samedi
                    </div>
                    <div class="uk-width-1-4 subtitle uk-margin-small-top">
                        Dimanche
                    </div>

                    <div class="uk-widith-1-4"></div>

                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.hourPrices[4]">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.hourPrices[5]">
                    </div>
                    <div class="uk-width-1-4">
                        <input class="uk-input uk-text-center" type="number" [(ngModel)]="prices.hourPrices[6]">
                    </div>
                </div>
            </div>
            <div class="uk-margin" *ngIf="prices.priceType === 'hours'">
                <label class="uk-form-label" for="form-horizontal-text">Maximum d'heures comptabilisé</label>
                <div class="uk-form-controls uk-position-relative">
                    <span class="uk-form-icon uk-form-icon-flip uk-margin-small-right small-font">h/jour</span>
                    <input class="uk-input" type="number" [(ngModel)]="prices.limitHourPerDay">
                </div>
            </div>
            <div class="uk-margin">
                <label class="uk-form-label" for="form-horizontal-text">Prix au kilomètre</label>
                <div class="uk-form-controls uk-position-relative">
                    <span class="uk-form-icon uk-form-icon-flip uk-margin-small-right small-font">€/km</span>
                    <input class="uk-input" type="number" [(ngModel)]="prices.kmPrice">
                </div>
            </div>
            <div class="uk-margin">
                <label class="uk-form-label" for="form-horizontal-text">Prix de la réservation</label>
                <div class="uk-form-controls uk-position-relative">
                    <span class="uk-form-icon uk-form-icon-flip uk-margin-small-right small-font">€</span>
                    <input class="uk-input" type="number" [(ngModel)]="prices.reservationPrice">
                </div>
            </div>
            <div class="uk-margin">
                <label class="uk-form-label" for="form-horizontal-text">Carburant inclus</label>

                <div style="margin-left: 15px" uk-form-custom="target: > * > span:first-child">
                    <select [(ngModel)]="prices.fuelIncluded">
                        <option [ngValue]="true">Oui</option>
                        <option [ngValue]="false">Non</option>
                    </select>
                    <button class="uk-button uk-button-default" type="button" tabindex="-1">
                        <span></span>
                    </button>
                </div>
            </div>
        </div>

        <!-- Modifiers -->
        <div class="uk-width-4-10">
            <h3 class="uk-heading-divider bold">Modifications</h3>
            <div uk-grid>
                <div class="uk-width-1-2">
                    <button (click)="updatePrices()" class="uk-width-1-1 button">
                        Valider les modifications
                    </button>
                </div>
            </div>
            <!-- a voir -->
            <!-- <h3 class="uk-heading-divider bold">Préconfigurations</h3>
            <div uk-grid class="presets">
                <div class="uk-width-1-2">
                    <button (click)="updatePriceFormFromModel(1)" class="uk-width-1-1 button">
                        Modèle 1
                    </button>
                </div>
                <div class="uk-width-1-2">
                    <button (click)="updatePriceFormFromModel(2)" class="uk-width-1-1 button">
                        Modèle 2
                    </button>
                </div>
            </div> -->
        </div>

        <!-- Discounts -->
        <div class="uk-width-10-10 uk-margin-large-top">
            <h3 class="uk-heading-divider bold">
                <span>Remises</span>
                <button class="uk-button uk-button-link uk-float-right regular" style="margin-top: 4px;" (click)="addDiscount()">
                    <span class="material-icons vertical-middle">add</span>
                    <span class="vertical-middle">Ajouter</span>
                </button>
            </h3>

            <div *ngIf="prices.discounts.length === 0">
                <span>Aucune remise n'est appliquée.</span>
            </div>

            <div *ngFor="let discount of prices.discounts; let i = index">
                <div class="uk-form-controls uk-grid-small" uk-grid style="margin-left: -15px; margin-top: 0px; margin-bottom: 15px;">
                    <div class="uk-width-1-1 discount-margin">
                        <input class="uk-input uk-text-center" style="width: 85px;" type="number" [(ngModel)]="discount.amount">
                        <div uk-form-custom="target: > * > span:first-child">
                            <select [ngModel]="discount.symbol" (ngModelChange)="changeSymbol(i, $event)">
                                <option value="%">%</option>
                                <option value="€">€</option>
                                <option value="km">KM</option>
                            </select>
                            <button class="uk-button uk-button-default" type="button" tabindex="-1">
                                <span></span>
                            </button>
                        </div>
                        <span *ngIf="discount.symbol === '%' || discount.symbol === '€'">à partir de</span>
                        <span *ngIf="discount.symbol === 'km'">inclus pour chaque</span>
                        <input *ngIf="discount.symbol !== 'km'" class="uk-input uk-text-center" style="width: 85px;" type="number" [(ngModel)]="discount.conditionAmount">
                        <span *ngIf="discount.symbol === '%'">jusqu'à</span>
                        <input *ngIf="discount.symbol === '%'" class="uk-input uk-text-center" style="width: 85px;" type="number" [(ngModel)]="discount.conditionAmountMax">
                        <div uk-form-custom="target: > * > span:first-child">
                            <select [(ngModel)]="discount.condition">
                                <option value="kilometers" *ngIf="discount.symbol !== 'km'">KM parcourus</option>
                                <option value="hours">heures réservées</option>
                                <option value="blocks">blocs réservés</option>
                            </select>
                            <button class="uk-button uk-button-default" type="button" tabindex="-1">
                                <span></span>
                            </button>
                        </div>
                        <button class="uk-button uk-button-link" (click)="removeDiscount(i)">
                            <span class="material-icons vertical-middle">delete</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Simulations -->
        <div class="uk-width-10-10 uk-margin-large-top">
            <h3 class="uk-heading-divider bold">
                <span>Simulateur</span>
                <button class="uk-button uk-button-link uk-float-right regular" style="margin-top: 4px; margin-left: 15px;" (click)="updateSimulations()">
                    <span class="material-icons vertical-middle">refresh</span>
                    <span class="vertical-middle">Rafraîchir</span>
                </button>
                <button class="uk-button uk-button-link uk-float-right regular" style="margin-top: 4px;" (click)="addSimulation()">
                    <span class="material-icons vertical-middle">add</span>
                    <span class="vertical-middle">Ajouter</span>
                </button>
            </h3>

            <div uk-grid>
                <div class="uk-width-1-2" *ngFor="let simulation of simulations; let i = index">
                    <div class="uk-form-horizontal uk-grid-small" uk-grid>
                        <div class="uk-width-1-1 uk-position-relative uk-card card">
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">Début</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <input class="uk-input uk-text-center" type="datetime-local" [(ngModel)]="simulation.start">
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">Fin</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <input class="uk-input uk-text-center" type="datetime-local" [(ngModel)]="simulation.end">
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">KM parcourus</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <input class="uk-input uk-text-center" type="number" [(ngModel)]="simulation.kilometers">
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">Durée totale</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <!--<input class="uk-input uk-form-blank uk-text-center" type="text" [(ngModel)]="simulation.totalTime" disabled>-->
                                    <legend class="uk-legend">{{simulation.totalTime}}</legend>
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">Montant kilométrique</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <legend class="uk-legend">{{simulation.kmAmount}}€</legend>
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">Montant horaire</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <legend class="uk-legend">{{simulation.hourAmount}}€</legend>
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">Montant réservation</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <legend class="uk-legend">{{simulation.reservationAmount}}€</legend>
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">Montant remises</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <legend class="uk-legend">{{simulation.discountAmount}}€</legend>
                                </div>
                            </div>
                            <div class="uk-margin">
                                <label class="uk-form-label simulation-label" for="form-horizontal-text">Montant total</label>
                                <div class="simulation-form" uk-form-custom="target: > * > span:first-child">
                                    <legend class="uk-legend">{{simulation.totalAmount}}€</legend>
                                </div>
                            </div>
                            <div class="delete-simulation">
                                <button class="uk-button uk-button-link" (click)="removeSimulation(i)">
                                    <span class="material-icons vertical-middle">delete</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>